import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    collections: [],
    loading: false,
    error: null,
    isCollectionPopupOpen: false,
};

function updateCollections(datasetList) {
    return datasetList.map((item) => {
        // Define a mapping for specific name changes
        const nameMapping = {
            "landsat-c2l2-sr": "Landsat-asia",
            "SENTINEL-2": "Sentinel-asia",
        };

        // Update the name if it matches the mapping
        const updatedName = nameMapping[item.name] || item.name;

        // Return the updated object with the new displayName key
        return {
            ...item,
            displayName: updatedName, // Use the updated name for displayName
        };
    });
}

const collectionSlice = createSlice({
    name: 'collectionSlice',
    initialState,
    reducers: {
        getCollectionsRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        getCollectionsSuccess: (state, action) => {
            state.loading = false;
            state.collections = updateCollections(action.payload);
        },
        getCollectionsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        createCollectionsRequest: (state) => {
            state.loading = true;
        },
        createCollectionsSuccess: (state) => {
            state.loading = false;
        },
        createCollectionsFailure: (state) => {
            state.loading = false;
        },
        togglePopup: (state) => {
            state.isCollectionPopupOpen = !state.isCollectionPopupOpen;
        }
    },
});
export default collectionSlice.reducer;

export const {
    getCollectionsRequest,
    getCollectionsSuccess,
    getCollectionsFailure,
    createCollectionsRequest,
    createCollectionsSuccess,
    createCollectionsFailure,
    togglePopup,
} = collectionSlice.actions;